var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',{staticClass:"title-report"},[_vm._v("Response by Days ("+_vm._s(_vm.type === 'devices' ? 'Devices' : 'Groups')+")")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('charts',{attrs:{"options":_vm.chartOptions}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ceb5f2c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/client/rounds/dashboard/graphs/ResponsesDevicesByDays.vue
// module id = null
// module chunks = 